import { render } from "./NumberInput.vue?vue&type=template&id=76002a19"
import script from "./NumberInput.vue?vue&type=script&lang=js"
export * from "./NumberInput.vue?vue&type=script&lang=js"
script.render = render

export default script